// Barra de filtros (slicers). Las opciones vienen del backend (`filters`), la
// definición de qué filtros mostrar viene de la config del cliente.
import React from 'react';

export default function FilterBar({ filters, options, value, onChange, theme }) {
  return (
    <div className="vz-filterbar">
      {filters.map((f) => {
        const opts = options?.[f.key] || [];
        return (
          <div className="vz-filter" key={f.key}>
            <label>{f.label}</label>
            <select
              value={value?.[f.key] || ''}
              onChange={(e) => onChange(f.key, e.target.value)}
              style={{ borderColor: theme.primary }}
            >
              <option value="">Todas</option>
              {opts.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
          </div>
        );
      })}
    </div>
  );
}
